import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './types';
import { FlagState } from '../experimentation/base';

export const preloadedExperiments = [
  'show_insurance_combo_screen',
  'ab_test_intro_screens',
] as const;
type ExperimentFlagsInRedux = typeof preloadedExperiments[number];

export type Experiments = { [flag in ExperimentFlagsInRedux]?: FlagState };

const initialState: Experiments = {};

export const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    setExperiments: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setExperiments } = experimentsSlice.actions;

export const selectExperiments = (state: RootState) => state.experiments;

export default experimentsSlice.reducer;
